import styled, { css } from 'styled-components';
import iconCruce from '../../../../../assets/icons/home/casuisticas/cruce.svg';
import IconRemoto from '../../../../../assets/icons/home/casuisticas/repro_remoto.svg';
import IconPresencial from '../../../../../assets/icons/home/casuisticas/repro_presencial.svg';

export const CardBody = styled.button.attrs((props: any) => ({
  cardType: props.cardType,
  isReprog: props.isReprog,
  isCruce: props.isCruce,
  styleType: props.styleType
}))`
  //   background: #0079d6;
  background-color: var(--button-course-${(props) => props.cardType}-main);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
  min-height: 99px;
  border: ${(props) =>
    ['E', 'A', 'R'].includes(props.cardType) ? '1px solid #0060AB' : 'none'};

  .container__hora--cruce {
    display: flex;
    gap: 16px;
  }

  .icon__repro {
    display: flex;
    gap: 4px;
  }

  .icon__repro > h1 {
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;
    align-self: center;
  }

  .icon__cruce {
    display: flex;
    gap: 4px;
  }

  .icon__cruce > h1 {
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;
    align-self: center;
  }

  &:hover {
    background-color: var(--button-course-${(props) => props.cardType}-hover);
    outline: 0;
  }
  &:active,
  &:focus {
    background: var(--button-course-${(props) => props.cardType}-focus);
    outline: 0;
  }

  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  ${(props) => {
    const caseA = css`
      &.repro {
        background-image: repeating-linear-gradient(
            30deg,
            var(--button-course-${props.cardType}-stripes1) 0px,
            var(--button-course-${props.cardType}-stripes1) 4px,
            var(--button-course-${props.cardType}-stripes2) 4px,
            var(--button-course-${props.cardType}-stripes2) 8px
          ),
          url(${props.isReprog && props.cardType === 'P'
            ? IconPresencial
            : IconRemoto});
        background-position: left top;
        background-size: 4px 9.25px;
        background-repeat: repeat-y;
      }
    `;

    switch (props.styleType) {
      case 'repro':
        return caseA;
      case 'line':
        return css`
          :nth-child(2) {
            &.line {
              // background-color: var(--decorative-decorative03);
              background-image: url(${iconCruce});
              background-position: left top;
              background-repeat: repeat-y;
            }
          }
        `;
      case 'line repro':
        return caseA;
      default:
        return css``;
    }
  }}

  @media (min-width: 992px) {
    .container__hora--cruce {
      gap: 14px;
    }
    .icon__repro > h1 {
      width: 43px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  @media (min-width: 1280px) {
    .container__hora--cruce {
      gap: 16px;
    }
    .icon__repro > h1 {
      overflow: initial;
    }
  }
`;

export const CardBody2 = styled.button`
  background: #83429f;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 8px;

  &:hover {
    background: #633179;
  }

  &:focus,
  active {
    background: #452056;
  }
`;

export const CardBodyTitle = styled.p`
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  //   max-width: 280px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  text-align: left;
  //   max-width: 250px;

  @media (min-width: 640px) {
    max-width: 280px;
  }

  @media (min-width: 768px) {
    max-width: 336px;
  }

  @media (min-width: 992px) {
    max-width: 164px;
  }

  @media (min-width: 1280px) {
    max-width: 240px;
  }
`;

export const CardBodyContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
  width: 100%;
`;

export const CardBodyBtn = styled.div.attrs((props: any) => ({
  background: props.background,
  color: props.color
}))`
  width: fit-content;
  background: ${(props: any) => props.background};
  border-radius: 20px;
  padding: 0px 10px;
  color: ${(props: any) => props.color};
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
`;

export const CardBodyBtn2 = styled.button`
  background: #ecdef5;
  border-radius: 4px;
  padding: 0px 10px;
  color: #83429f;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
`;

export const CardBodyCourse = styled.div`
  display: flex;
`;

export const CardBodyParahraph = styled.p`
  margin-right: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  align-self: center;
  margin-left: 4px;

  @media (min-width: 992px) {
    display: none;
  }

  @media (min-width: 1280px) {
    display: block;
  }
`;

export const CardBodyImg = styled.img``;
